import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$axios = axios

//引用WebViewJavascriptBridge
import bridge from './utils/bridge.js' 
Vue.prototype.$bridge=bridge;

import 'amfe-flexible'

// 取消全局引入
// import Vant from 'vant';
import 'vant/lib/index.css';
// Vue.use(Vant);

import { Field } from 'vant';
Vue.use(Field);
import { Toast } from 'vant';
Vue.use(Toast);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
